module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/upgrade-to-vux2-300.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/install/upgrade-to-vux2.md
// module id = 764
// module chunks = 386